import { TimeIcon1, TimeIcon2, TimeIcon3, ArrowRight } from "../../constants/ImagePaths";

import Image from "../../components/general/Image";

const content = [
    {
        img: TimeIcon1,
        title: "From startups to enterprise",
        desc: "Whether you're pre-seed or scaling globally, we plug in the right talent at every stage."
    },
    {
        img: TimeIcon2,
        title: "Engineers that ship from day one",
        desc: "No learning curve. No lag. Our devs hit the ground running."
    },
    {
        img: TimeIcon3,
        title: "Long-term talent retention",
        desc: "Most of our clients stay with the same developer for 12+ months."
    }
]

const TimeSection = () => {
    return (
        <section className="relative !py-[100px] bg-[#292929]">
            <div className="--layout-padding max-width">
                <div className="flex flex-col gap-[20px] md:grid md:grid-cols-2 lg:grid-cols-3 lg:px-[100px] lg:gap-[50px]">
                    {
                        content.map((item, index) => (
                            <div key={index} className="bg-[#141414] text-white rounded-[20px] text-292929 py-[50px] px-[20px]">
                                <Image src={item.img} alt={item.title} className='mb-[20px]' />
                                <h3 className="text-[25px] font-semibold">{item.title}</h3>
                                <p className="text-[14px]">{item.desc}</p>
                            </div>
                        ))
                    }
                </div>
            </div>

            <Image src={ArrowRight} alt="ArrowRight" className='hidden lg:block absolute bottom-[-65px] right-0 w-[250px]' />
        </section>
    );
};
export default TimeSection;